export enum Password {
  MIN_LENGTH = 6,
  /** Предел BCrypt на сервере (72 байта; кириллица весит 2 байта на символ — сервер проверяет байты сам). */
  MAX_LENGTH = 72
}
